/* ProGym SE — lightweight motion. GPU transforms/opacity only. No libraries. */
(function () {
  'use strict';

  var root = document.documentElement;
  var forced = root.classList.contains('reduce-motion');
  var osReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reduced = forced || osReduced;

  /* ---- blur-up: mark images loaded ---- */
  function markLoaded(img) { img.classList.add('is-loaded'); }
  var blurups = document.querySelectorAll('.blurup');
  for (var i = 0; i < blurups.length; i++) {
    var im = blurups[i];
    if (im.complete && im.naturalWidth) markLoaded(im);
    else im.addEventListener('load', function () { markLoaded(this); }, { once: true });
  }

  /* ---- prose scroll-reveal: tag direct children ---- */
  var prose = document.querySelector('.prose');
  if (prose) {
    var kids = prose.children;
    for (var k = 0; k < kids.length; k++) {
      kids[k].classList.add('reveal');
    }
  }

  if (reduced) {
    // Ensure everything is visible immediately; still light today-glow (static).
    var rv = document.querySelectorAll('.reveal');
    for (var r = 0; r < rv.length; r++) rv[r].classList.add('is-in');
    highlightToday();
    var nums = document.querySelectorAll('[data-count]');
    for (var n = 0; n < nums.length; n++) nums[n].textContent = formatNum(nums[n]);
    setupProgress(true);
    setupNav();
    return;
  }

  /* ---- shared IntersectionObserver: reveal + count-up ---- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      if (el.classList.contains('reveal')) el.classList.add('is-in');
      if (el.hasAttribute('data-count')) countUp(el);
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.15 });

  document.querySelectorAll('.reveal, [data-count]').forEach(function (el) { io.observe(el); });

  /* ---- count-up with glow trail ---- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var dur = 1200, start = null;
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var decimals = (String(target).split('.')[1] || '').length;
    el.classList.add('is-counting');
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      el.textContent = prefix + val.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.classList.remove('is-counting');
    }
    requestAnimationFrame(step);
  }
  function formatNum(el) {
    var t = parseFloat(el.getAttribute('data-count')) || 0;
    var decimals = (String(t).split('.')[1] || '').length;
    return (el.getAttribute('data-prefix') || '') +
      t.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      (el.getAttribute('data-suffix') || '');
  }

  /* ---- schedule: glow today ---- */
  function highlightToday() {
    var today = new Date().getDay(); // 0 Sun .. 6 Sat
    var days = document.querySelectorAll('[data-weekday]');
    for (var d = 0; d < days.length; d++) {
      if (parseInt(days[d].getAttribute('data-weekday'), 10) === today) days[d].classList.add('is-today');
    }
  }
  highlightToday();

  /* ---- reading progress ---- */
  function setupProgress(isStatic) {
    var bar = document.querySelector('.progress__fill');
    if (!bar) return;
    var article = document.querySelector('[data-progress-target]') || document.querySelector('.prose');
    function update() {
      var ref = article || document.body;
      var rect = ref.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var passed = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      bar.style.width = (total > 0 ? (passed / total) * 100 : 0) + '%';
    }
    if (isStatic) { update(); return; }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(function () { update(); ticking = false; }); ticking = true; }
    }, { passive: true });
    update();
  }
  setupProgress(false);

  /* ---- nav toggle ---- */
  function setupNav() {
    var t = document.querySelector('.nav-toggle');
    var nav = document.querySelector('.nav');
    if (!t || !nav) return;
    t.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  setupNav();
})();
